var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-component',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(ref){
var touch = ref.touch;
var faulty = ref.faulty;
return [_c('input',_vm._b({staticClass:"inp",class:{faulty: faulty},attrs:{"type":"password"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"blur":touch}},'input',_vm.$attrs,false))]}}])},'error-component',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }